<template>
  <div>
    <div class="level new-ending">
      <div class="level-left">
        <div class="level-item">
          <h1 class="subtitle">
            Ending: {{ alternateEnding.attributes.alternateEndingHeader }}
          </h1>
        </div>
      </div>
      <div class="level-right" v-if="canEdit">
        <div class="level-item">
          <div v-if="!editAlternateEnding">
            <button
              class="button is-info is-small"
              @click="toggleEditAlternateEnding"
            >
              Edit
            </button>
            <button
              :disabled="canDelete"
              class="button is-link"
              @click="deleteAlternateEnding(endingId)"
            >
              Delete
            </button>
          </div>
          <div v-if="editAlternateEnding">
            <button
              :class="[
                'button',
                'is-primary',
                'is-small',
                { 'is-loading': loadingAlternateEnding }
              ]"
              @click="saveAlternateEnding"
            >
              Update
            </button>
            <button class="button is-small" @click="toggleEditAlternateEnding">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="question info" v-if="!editAlternateEnding">
      <h4>{{ alternateEnding.attributes.alternateEndingHeader }}</h4>
      <p>
        <span v-html="alternateEnding.attributes.alternateEndingMessage"></span>
      </p>
      <p
        v-if="
          alternateEnding.attributes.alternateEndingButtonLabel &&
            alternateEnding.attributes.alternateEndingButtonUrl
        "
      >
        <a :href="alternateEnding.attributes.alternateEndingButtonUrl">{{
          alternateEnding.attributes.alternateEndingButtonLabel
        }}</a>
      </p>
    </div>

    <div class="question edit" v-if="editAlternateEnding">
      <div class="field">
        <label class="label">Header</label>
        <div class="control mt-2">
          <input type="text" class="input" v-model="alternateEndingHeader" />
        </div>
      </div>

      <div class="field">
        <label class="label">Message</label>
        <div class="control mt-2">
          <quill-editor
            v-model="alternateEndingMessage"
            :options="editorOptions"
          ></quill-editor>
        </div>
      </div>

      <div class="field">
        <label class="label">Status Override</label>
        <p>
          What is set here will override the default status of the patient
          submission in queue.
        </p>
        <div class="control mt-2">
          <multiselect
            name="alternateEndingStatusOverride"
            v-model="alternateEndingStatusOverride"
            track-by="id"
            label="label"
            placeholder="Select one"
            :options="statusListOptions"
          >
          </multiselect>
        </div>
      </div>

      <div class="field">
        <label class="label">Show On-Demand Session Button</label>
        <p>
          This will show a button that will allow a user to start an on-demand
          session.
        </p>
        <div class="select control mt-2">
          <select
            name="alternateEndingShowOndemandSessionButton"
            v-model="alternateEndingShowOndemandSessionButton"
          >
            <option
              v-for="opt in showOnDemandSessionButtonOptions"
              :value="opt.value"
              v-bind:key="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="mb1" v-if="alternateEndingShowOndemandSessionButton">
        <div class="control field-options">
          <label class="label">Message</label>
          <quill-editor
            v-model="alternateEndingOnDemandMessage"
            :options="onDemandEditorOptions"
          ></quill-editor>
        </div>
        <div class="control field-options">
          <label class="label">Button Text</label>
          <input
            class="input"
            type="text"
            v-model="alternateEndingOnDemandButtonText"
            name="ondemand_button_text"
          />
        </div>
      </div>

      <a @click="toggleCallToActionButton" class="button">
        <span v-if="!showCallToActionButton">Add Call To Action Button</span>
        <span v-else>Remove Call To Action Button</span>
      </a>

      <div class="add-call-to-action-button" v-if="showCallToActionButton">
        <br />
        <h3>Call To Action Button</h3>
        <div class="field">
          <label class="label">Button Text</label>
          <div class="control mt-2">
            <input
              type="text"
              class="input"
              v-model="alternateEndingButtonLabel"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">Button Link</label>
          <div class="control mt-2">
            <input
              type="text"
              class="input"
              v-model="alternateEndingButtonUrl"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import { quillEditor } from "vue-quill-editor";
import Multiselect from "vue-multiselect";
import { getToolbarOptions } from "../../helpers/editor";

export default {
  name: "alternate-ending",

  props: ["interview", "canEdit", "endingId"],

  components: {
    quillEditor,
    Multiselect
  },

  data() {
    return {
      shouldShowCallToActionButton: false,
      editAlternateEnding: false,
      alternateEndingHeader: null,
      alternateEndingMessage: null,
      alternateEndingStatusOverride: null,
      alternateEndingShowOndemandSessionButton: null,
      alternateEndingOnDemandMessage: "",
      alternateEndingOnDemandButtonText: "",
      alternateEndingButtonLabel: null,
      alternateEndingButtonUrl: null,
      loadingAlternateEnding: false,
      cloneLoading: false,
      showOnDemandSessionButtonOptions: [
        { value: true, label: "Yes" },
        { value: false, label: "No" }
      ],
      editorOptions: getToolbarOptions("Next steps..."),
      onDemandEditorOptions: getToolbarOptions("Message...")
    };
  },

  watch: {
    alternateEndingShowOndemandSessionButton(newVal, oldVal) {
      console.log("newVal=", newVal);
      console.log("oldVal=", oldVal);
      if (newVal === false || newVal === null) {
        this.alternateEndingOnDemandMessage = "";
        this.alternateEndingOnDemandButtonText = "";
      }
    }
  },

  computed: {
    statusListOptions() {
      let statuses = this.$store.getters["patientQueue/statusList"];
      if (statuses) {
        let statusKeys = Object.keys(statuses);

        statuses = _.reduce(
          statusKeys,
          function(collection, key) {
            collection.push({
              id: key,
              label: statuses[key]
            });
            return collection;
          },
          []
        );
      }
      return statuses ? statuses : [];
    },
    showCallToActionButton() {
      if (this.shouldShowCallToActionButton == true) {
        return true;
      } else if (
        this.alternateEndingButtonLabel &&
        this.alternateEndingButtonUrl
      ) {
        this.shouldShowCallToActionButton = true;
        return true;
      } else {
        return false;
      }
    },
    canDelete() {
      if (
        this.interview.alternateEndings &&
        this.interview.alternateEndings.count > 1
      ) {
        return true;
      }
      return false;
    },
    alternateEnding() {
      return this.interview.alternateEndings[this.endingId];
    }
  },
  methods: {
    deleteAlternateEnding(endingId) {
      InterviewsService.deleteAlternateEnding(this.interview.id, endingId);
    },
    toggleCallToActionButton() {
      this.shouldShowCallToActionButton = !this.shouldShowCallToActionButton;
      if (this.shouldShowCallToActionButton === false) {
        this.alternateEndingButtonLabel = "";
        this.alternateEndingButtonUrl = "";
      }
    },
    showEditAlternateEndingTrigger(id) {
      this.endingMenu = null;
      this.endingEdit = id;
    },
    toggleEditAlternateEnding() {
      this.alternateEndingHeader = this.alternateEnding.attributes.alternateEndingHeader;
      this.alternateEndingMessage = this.alternateEnding.attributes.alternateEndingMessage;
      this.alternateEndingButtonLabel = this.alternateEnding.attributes.alternateEndingButtonLabel;
      this.alternateEndingButtonUrl = this.alternateEnding.attributes.alternateEndingButtonUrl;
      this.alternateEndingShowOndemandSessionButton = this.alternateEnding.attributes.alternateEndingShowOndemandSessionButton;
      this.alternateEndingOnDemandMessage = this.alternateEnding.attributes.alternateEndingOnDemandMessage;
      this.alternateEndingOnDemandButtonText = this.alternateEnding.attributes.alternateEndingOnDemandButtonText;
      let statuses = this.$store.getters["patientQueue/statusList"];
      if (statuses) {
        this.alternateEndingStatusOverride = {
          id: this.alternateEnding.attributes.statusOverride,
          label: statuses[this.alternateEnding.attributes.statusOverride]
        };
      }

      this.editAlternateEnding = !this.editAlternateEnding;
    },
    saveAlternateEnding() {
      this.loadingAlternateEnding = true;
      this.alternateEnding.attributes.alternateEndingHeader = this.alternateEndingHeader;
      this.alternateEnding.attributes.alternateEndingMessage = this.alternateEndingMessage;
      this.alternateEnding.attributes.alternateEndingButtonLabel = this.alternateEndingButtonLabel;
      this.alternateEnding.attributes.alternateEndingButtonUrl = this.alternateEndingButtonUrl;
      this.alternateEnding.attributes.alternateEndingShowOndemandSessionButton = this.alternateEndingShowOndemandSessionButton;
      this.alternateEnding.attributes.alternateEndingOnDemandMessage = this.alternateEndingOnDemandMessage;
      this.alternateEnding.attributes.alternateEndingOnDemandButtonText = this.alternateEndingOnDemandButtonText;

      this.alternateEnding.attributes.statusOverride = (
        this.alternateEndingStatusOverride || {}
      ).id;
      InterviewsService.updateAlternateEnding(
        this.interview.id,
        this.alternateEnding
      ).then(() => {
        this.loadingAlternateEnding = false;
        this.editAlternateEnding = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
